import {
    Component,
    EventEmitter,
    Input,
    Output,
    OnInit,
    ViewChild
} from '@angular/core';
import { LazyLoadEvent, TreeNode } from 'primeng/api';
import { AccountService } from '../service/account.service';
import { LookupService } from '../service/lookup.service';
import { TreeTable } from 'primeng/treetable';
import { IdName } from '../domain/idname';
import * as _ from 'lodash';

@Component({
    selector: 'app-tree-accounts',
    templateUrl: './tree-accounts.component.html',
    styles: [
        `
            :host ::ng-deep .priority-2,
            :host ::ng-deep .priority-3,
            :host ::ng-deep .visibility-sm {
                display: none;
            }

            @media screen and (max-width: 39.938em) {
                :host ::ng-deep .visibility-sm {
                    display: inline;
                }
            }

            @media screen and (min-width: 40em) {
                :host ::ng-deep .priority-2 {
                    display: table-cell;
                }
            }

            @media screen and (min-width: 64em) {
                :host ::ng-deep .priority-3 {
                    display: table-cell;
                }
            }
        `
    ]
})
export class TreeAccountsComponent implements OnInit {
    constructor(
        private accountService: AccountService,
        private lookupService: LookupService
    ) {
        // tslint:disable-next-line: max-line-length
        this.cols = [{ field: 'code', header: 'Code', width: '30%' },  { field: 'lineNumbers', header: 'Line#', width: '20%' }, { field: 'name', header: 'Name', width: '50%' }];

        this.items = [
            {
                label: 'Collapse All',
                icon: 'ui-expand-less',
                command: event => this.collapse()
            },
            {
                label: 'Expand All',
                icon: 'ui-expand-more',
                command: event => this.expand()
            }
        ];
    }

    @Input() selectionMode: string;
    @Input() loadingAccounts = true;
    @Input() cols: any[];
    @Input() reportId: string;
    @Input() excluded: boolean;
    @Input() excludedForReport: boolean;
    @Input() range: boolean;
    @Input() included: boolean;
    @Input() all: boolean;
    @Input() removeLoader: boolean;
    @Output() voted = new EventEmitter<boolean>();

    @ViewChild('tree', { static: false }) tree: TreeTable;

    @Input() filter: IdName[];

    @Input() selected: TreeNode;
    _selectedLines: any;
    @Output() unselectedNode = new EventEmitter<TreeNode>();

    @Input() set selectedLines(value: any) {
        this._selectedLines = value;
        if (value && !Array.isArray(value)) {
            this.refresh();
        }
    }

    get selectedLines() {
        return this._selectedLines;
    }

    _lineId: any;

    @Input() set lineId(value: any) {
        this._lineId = value;
    }

    get lineId() {
        return this._lineId;
    }

    @Output() selectedChange = new EventEmitter<TreeNode>();
    @Output() onSearchEnter = new EventEmitter<TreeNode[]>();

    didVote = false;

    totalAccountsNumber: number;
    @Output() accounts: TreeNode[];
    fullAccountsData: TreeNode[];
    leafs: TreeNode[];
    searchValue: string;

    items: any[];

    toggleLeavesOnly = false;

    ngOnInit() {
        this.refresh();
        this.searchValue = null;
    }

    // tslint:disable-next-line: use-lifecycle-interface
    ngOnChanges() {


    }

    changeToggleLeavesOnly() {
        if (this.toggleLeavesOnly) {
            this.loadingAccounts = true;
            this.leafs = [];
            this.processLeafs();
            this.accounts = this.leafs;
            this.loadingAccounts = false;
        } else {
            this.refresh();
        }
    }

    getLineNumbers(lineNumbers: string) {
        let retVal = '(' + lineNumbers + ')';

        if (retVal === '()') {
            retVal = '';
        }

        return retVal;
    }

    collapse() {
        if (this.accounts) {
            this.accounts.forEach(node => {
                this.expandRecursive(node, false);
            });
            this.accounts = [...this.accounts];
        }
    }

    private expandRecursive(node: TreeNode, isExpand: boolean) {
        node.expanded = isExpand;
        if (!node.leaf && node.children != null) {
            node.children.forEach(childNode => {
                this.expandRecursive(childNode, isExpand);
            });
        }
    }

    expand() {
        this.accounts.forEach(node => {
            this.expandRecursive(node, true);
        });
        this.accounts = [...this.accounts];
    }

    leafsRecursive(node: TreeNode) {
        if (node.leaf) {
            node.data.leaf = true;
            this.leafs.push(node);
        }
        if (node.children) {
            node.children.forEach(childNode => {
                this.leafsRecursive(childNode);
            });
        }
        node.children = null;
    }

    processLeafs() {
        this.accounts.forEach(node => {
            this.leafsRecursive(node);
        });
    }

    processAccountsRecursive(node: TreeNode) {
        if (node.leaf) {
            //color all leaves
            node.data.leaf = true;
        }
        if (node.children) {
            node.children.forEach(childNode => {
                this.processAccountsRecursive(childNode);
            });
        }

        //handle too much line numbers
        /*if ((node.data.lineNumbers.match(/,/g) || []).length > 5) {
            node.data.lineNumbersExtended = node.data.lineNumbers.replace(/((?:[^,]*,){5}[^,]*),/g, '$1<br\/>');
            node.data.lineNumbers = node.data.lineNumbers.split(",").splice(0, 5) + "...";
        }*/
    }

    processAccounts() {
        this.accounts.forEach(node => {
            this.processAccountsRecursive(node);
        });
    }

    public refresh(highlightedIds: [] = null, highlightedRangeIds: [] = null) {
        if (this.removeLoader) {
            this.loadingAccounts = false;
        } else {
            this.loadingAccounts = true;
        }
        if (this.excluded && this.lineId !== undefined) {
            this.accountService
                .getExcludedForLine(this.lineId)
                .then(objects => {
                    this.fullAccountsData = objects;
                    this.accounts = objects;
                    this.collapse();
                    // obriši sve accounte iz ostalih chipseva (singles)
                    if (
                        this.accountService.allAccountsTotalingsIds !==
                            undefined &&
                        this.accountService.allAccountsTotalingsIds.length >= 1
                    ) {
                        this.accountService.allAccountsTotalingsIds.forEach(
                            selectedAccountId => {
                                this.accounts.forEach(parentNode => {
                                    if (
                                        parentNode.data.id === selectedAccountId
                                    ) {
                                        this.accounts.splice(
                                            this.accounts.findIndex(
                                                value =>
                                                    value.data.id ===
                                                    parentNode.data.id
                                            ),
                                            1
                                        );
                                    } else {
                                        this.deleteNodeById(
                                            parentNode,
                                            selectedAccountId
                                        );
                                    }
                                });
                            }
                        );
                    }

                    // obriši sve account iz ostalih chipseva (ranges)
                    if (
                        this.accountService.allAccountsTotalingRanges !==
                            undefined &&
                        this.accountService.allAccountsTotalingRanges.length >= 1
                    ) {
                        this.accountService.allAccountsTotalingRanges.forEach(
                            rangeIds => {
                                if (rangeIds[0] >= 1 && rangeIds[1] >= 1) {
                                    // find range start
                                    const startIndex = this.accounts.findIndex(
                                        value =>
                                            value.data.id === rangeIds[0]
                                    );
                                    // find range end
                                    const endIndex = this.accounts.findIndex(
                                        value =>
                                            value.data.id === rangeIds[0]
                                    );
                                    // delete all in range
                                    this.accounts.splice(
                                        startIndex,
                                        endIndex - startIndex
                                    );
                                }
                            }
                        );
                    }

                    if (highlightedIds) {
                        highlightedIds.forEach(id => {
                            this.accounts.find(a => a.data.id === id).data.highlighted = true;
                        });
                    }

                    this.clearSelection();
                    this.loadingAccounts = false;

                }).then(() => {
                    this.processAccounts();
                });
            return;
        } else if (this.range && this.lineId !== undefined) {
            this.accountService
            .getExcludedForLine(this.lineId)
            .then(objects => {
                this.accounts = objects;
                this.collapse();
                if (this._selectedLines) {
                    if (this._selectedLines.parent) {
                        const accountForTree = _.cloneDeep(this._selectedLines.parent.children);

                        accountForTree.forEach( n => {
                            n.children = null;
                            n.expanded = false;
                            n.leaf = true;
                        });

                        const accountsFinal = [];

                        accountForTree.forEach( n => {
                            if (n.data.code > this.selectedLines.data.code) {
                                accountsFinal.push(n);
                            }
                        });



                        this.accounts = accountsFinal;
                    } else {
                        const accountForTree = _.cloneDeep(objects);

                        accountForTree.forEach( n => {
                            n.children = null;
                            n.expanded = false;
                            n.leaf = true;
                        });
                        this.accounts = accountForTree;

                        const accountsFinal = [];

                        accountForTree.forEach( n => {
                            if (n.data.code > this.selectedLines.data.code) {
                                accountsFinal.push(n);
                            }
                        });

                        this.accounts = accountsFinal;
                        this.loadingAccounts = false;
                    }
                }

            }).then(() => {
                this.processAccounts();
            });

            return;
        } else if (this.included) {
            this.accountService
                .getIncluded(this.reportId, this.filter)
                .then(objects => {
                    this.accounts = objects;
                    this.collapse();
                    this.loadingAccounts = false;
                    this.processAccounts();
                });
            return;
        } else if (this.excludedForReport) {
            this.accountService
                .getExcluded(this.reportId, this.filter)
                .then(objects => {
                    this.accounts = objects;
                    this.collapse();
                    this.loadingAccounts = false;
                    this.processAccounts();
                });
            return;
        } else if (this.lineId) {
            this.accountService
                .getForLine(this.lineId)
                .then(objects => {
                    this.accounts = objects;
                    this.collapse();
                    this.loadingAccounts = false;
                    this.processAccounts();
                });
            return;
        } else if (this.all) {
            this.accountService
                .getAll(this.reportId, this.filter)
                .then(objects => {
                    this.accounts = objects;
                    this.collapse();
                    this.loadingAccounts = false;
                    this.processAccounts();
                });
            return;
        } else {
            this.accountService
                .getIncluded(this.reportId, this.filter)
                .then(objects => {
                    this.accounts = objects;
                    this.collapse();
                    this.loadingAccounts = false;
                    this.processAccounts();
                });
            return;
        }
    }


    filterLeafAndExpandedNodes(accounts: TreeNode[]) {
        const filteredAccount = [];
        accounts.forEach(account => {
            const accountCopy = Object.assign({}, account);
            if (accountCopy.leaf) {
                filteredAccount.push(accountCopy);
            } else {
                if (!account.expanded) {
                    accountCopy.children = [];
                    filteredAccount.push(accountCopy);
                } else {
                   if (accountCopy.children && accountCopy.children.length > 0) {}
                   accountCopy.children = this.filterLeafAndExpandedNodes(accountCopy.children);
                   filteredAccount.push(accountCopy);
                }
            }
        });
        return filteredAccount;
    }


    clearSelection() {
        this.selected = null;
    }

    deleteNodeById(topNode: TreeNode, id: number) {
        if (topNode.children != null) {
            let i;
            for (i = 0; i < topNode.children.length; i++) {
                if (topNode.children[i].data.id === id) {
                    topNode.children.splice(i, 1);
                    return;
                } else { this.deleteNodeById(topNode.children[i], id); }
            }
        } else { return; }
    }

    onNode() {
        this.selectedChange.emit(this.selected);
    }

    unselectNode(value) {
        this.unselectedNode.emit(value.node);
    }

    onNodeExpand(event) {
        const node = event.node;

        if (node.children === undefined) {
            this.loadingAccounts = true;

            this.accountService.children(this.reportId, node.data.id).then(data => {
                node.children = [...data];
                this.accounts = [...this.accounts];
                this.loadingAccounts = false;
            });
        }
    }

    transferOnEnter()
    {
        if (this.toggleLeavesOnly) {
            if (!this.range)
            {
                this.onSearchEnter.emit(this.tree.filteredNodes);
                this.searchValue = null;
                this.tree.filterGlobal("", "contains");
            }
        }
    }
}
